import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const adminApi = (key) =>
  axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json", "X-Admin-Key": key },
  });

export const PRICING = {
  current_per_month: 3,
  past_due_per_month: 10,
  setup_per_account: 5,
  monthly_minimum: 500,
  onboarding_one_time: 5000,
  compliance_monthly: 40000,
};

export const fmt = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(n || 0);

export const fmtInt = (n) => new Intl.NumberFormat("en-US").format(Math.round(n || 0));
export const fmtPct = (n) => `${(n * 100).toFixed(2)}%`;

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-US", { month: "short", day: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const fmtDuration = (ms) => {
  if (!ms || ms < 1000) return "<1s";
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}m ${r}s`;
};
